export default {
  getAutocompleteVatDeclarations: (state) => state.autocompleteVatDeclarations,
  getVatDeclarations: (state) => state.vatDeclarations,
  getVatDeclarationsContext: (state) => state.vatDeclarationsContext,
  getVatDeclaration: (state) => (id) => {
    return state.vatDeclarations.find(vatDeclaration => vatDeclaration.id === parseInt(id))
  },
  getEmptyVatDeclaration: (state) => JSON.parse(JSON.stringify(state.emptyVatDeclaration)),
}